<script setup>
import { computed, watch } from 'vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useLocoI18n } from 'custom/composables/useLocoI18n';
import { useInboxSettings } from './useInboxSettings';

// Tells agents other than the assignee that only private notes are open to them (the server enforces it)
const { t } = useLocoI18n();
const currentChat = useMapGetter('getSelectedChat');
const currentUser = useMapGetter('getCurrentUser');
const currentRole = useMapGetter('getCurrentRole');
const { settingsFor, fetchSettings } = useInboxSettings();

const inboxId = computed(() => currentChat.value?.inbox_id);
const assignee = computed(() => currentChat.value?.meta?.assignee);

watch(inboxId, id => fetchSettings(id), { immediate: true });

const locked = computed(() => {
  const settings = settingsFor(inboxId.value);
  if (!settings?.reply_lock || !assignee.value) return false;
  if (currentRole.value === 'administrator') return false;
  return assignee.value.id !== currentUser.value?.id;
});
</script>

<template>
  <Banner v-if="locked" color="amber" class="mx-2 mb-1">
    {{ t('LOCO.REPLY_LOCK.BANNER', { name: assignee.name }) }}
  </Banner>
</template>
